module.exports = __webpack_public_path__ + "assets/img/Main material (21).8fec38bb.jpg";